/**
 * The signed-in user's own display preferences (decision S4):
 *   GET /users/me/preferences  - override, organization setting, effective system
 *   PUT /users/me/preferences  - set ('metric' | 'imperial') or clear (null) the override
 */
import { apiClient } from './client';
import type { MeasurementSystem } from '@/utils/units';

export interface MeasurementPreferences {
  measurementSystemOverride: MeasurementSystem | null;
  organizationMeasurementSystem: MeasurementSystem;
  effectiveMeasurementSystem: MeasurementSystem;
}

/** Reads the caller's measurement preferences via GET /users/me/preferences. */
export async function getMyMeasurementPreferences(): Promise<MeasurementPreferences> {
  const res = await apiClient.get('/users/me/preferences');
  return (res.data.data ?? res.data) as MeasurementPreferences;
}

/** Sets or clears (null = use the organization's) the caller's measurement system via PUT /users/me/preferences. */
export async function updateMyMeasurementPreferences(
  measurementSystemOverride: MeasurementSystem | null,
): Promise<MeasurementPreferences> {
  const res = await apiClient.put('/users/me/preferences', { measurementSystemOverride });
  return (res.data.data ?? res.data) as MeasurementPreferences;
}
